import React, { useState } from "react";
import cn from "classnames";
import { Icon } from "../Icon/Icon";
import { Text } from "../Typography";
import defaultClassName from "../../scss/defaultClassName";
import "./MenuBar.scss";
/**
 * MenuBar component.
 * @param items - The elements in the menu bar.
 * @param orientation - Whether the menu bar is vertical or horizontal.
 * @param collapsable - Whther the menu is collapsable. Only vertical
 *  menues are collapsable.
 * @param collapsed - Whether the menu bar is in the collapsed state or not.
 * @param defaultCollapsed - Whether the menu is collapsed by default.
 * @param selected - The key of the item to select. This will override the
 * @param sticky - If the menuBar wrapping div should be sticky according to the
 *  nearest scrollable ancestor.
 *  internal selection state.
 * @returns MenuBar
 */
const Sidebar = ({ items = [], orientation = "vertical", collapsable = true, collapsed = false, defaultCollapsed = false, selected = undefined, sticky = false, wide = false, ...props }) => {
    // TODO: allow consumer to pass in a wrapper, like <NavLink> and utilize :active state
    //  for styling. Avoids needing to set onClicks and currentSelected
    const [_collapsed, _setCollapsed] = useState(collapsed || defaultCollapsed || false);
    const [_selected, _setSelected] = useState(items[0].key);
    const [_hovering, _setHovering] = useState(undefined);
    const getTheme = (key) => {
        if (_hovering === key)
            return "primary";
        if ((selected ?? _selected) === key)
            return "primary";
        return "secondary";
    };
    const className = cn(defaultClassName, "menu-bar", orientation, props.className, {
        collapsed: _collapsed,
        sticky,
        wide,
    });
    const firstFooterItem = items.findIndex((i) => i.footer);
    return (React.createElement("div", { className: className },
        items?.map((item, i) => (React.createElement("div", { key: i, className: cn("menu-bar-item", {
                selected: selected ? selected === item.key : _selected === item.key,
                footer: collapsable &&
                    orientation === "vertical" &&
                    firstFooterItem === i,
                clickable: item.onClick,
            }), onClick: (e) => {
                if (item.onClick) {
                    item.onClick(e);
                    if (!selected)
                        _setSelected(item.key);
                }
            }, onMouseEnter: () => _setHovering(item.key), onMouseLeave: () => _setHovering(undefined) },
            item.icon,
            !_collapsed && (React.createElement(Text, { size: "md", theme: getTheme(item.key) }, item.text))))),
        collapsable && orientation === "vertical" && (React.createElement("div", { className: cn("menu-bar-item", {
                footer: firstFooterItem === -1,
                clickable: true,
            }), onClick: () => {
                if (!collapsed)
                    _setCollapsed((prev) => !prev);
            } },
            React.createElement(Icon, { size: "lg", theme: "secondary", iconClassName: _collapsed ? "fa-angles-right" : "fa-angles-left" }),
            !_collapsed && (React.createElement(Text, { size: "md", theme: "secondary" }, "Collapse"))))));
};
export default Sidebar;
//# sourceMappingURL=MenuBar.js.map